<template>
  <a-spin size="large" :spinning="loading">
    <div class="workshop-container">
      <template v-if="step == 1">
        <!-- 标题区域 -->
        <div class="header">
          <div class="title" :class="[lang]">
            <a-icon
              type="home"
              class="icon"
              :style="{ 'margin-left': lang == 'AR' ? '5px' : 0 }"
            />
            {{ campaign_type == 1 ? $t("AIWorkshop") : $t("AIWorkRecruiter") }}
          </div>
          <div class="subtitle">
            {{ $t("AIconverse") }}
          </div>
        </div>
        <div class="m-title" :class="[lang]">
          <a-icon
            type="message"
            class="icon"
            :style="{ 'margin-left': lang == 'AR' ? '5px' : 0 }"
          />
          {{ $t("SetupMethod") }}
        </div>

        <!-- 选择对话设置方法区域 -->
        <div class="setup-methods">
          <div class="method-card" :body-style="{ padding: '20px' }">
            <div class="wrap-icon"><a-icon class="icon" type="flag" /></div>
            <div class="title" :class="[lang]">{{ $t("AIWorkflow") }}</div>

            <div class="description" :class="[lang]">
              {{ $t("StandardProcessBased") }}
            </div>
            <div class="features">
              <div class="item" :class="[lang]">
                {{ $t("Readyuse") }}
              </div>
              <div class="item" :class="[lang]">
                {{ $t("Highconversion") }}
              </div>
              <div class="item" :class="[lang]">
                {{ $t("Adjustable") }}
              </div>
            </div>
            <div class="wrap-btn">
              <a-button
                class="btn"
                :class="[lang]"
                type="primary"
                @click="selectHandler"
                >{{ $t("Select") }}</a-button
              >
            </div>
          </div>

          <div class="method-card" :body-style="{ padding: '20px' }">
            <div class="wrap-icon">
              <a-icon class="icon" type="dashboard" />
            </div>
            <div class="title" :class="[lang]">{{ $t("TrainingAI") }}</div>

            <div class="description" :class="[lang]">
              {{ $t("TrainAIStyle") }}
            </div>
            <div class="features">
              <div class="item" :class="[lang]">
                {{ $t("Fullycustomizable") }}
              </div>
              <div class="item" :class="[lang]">
                {{ $t("Styleadaptation") }}
              </div>
              <div class="item" :class="[lang]">
                {{ $t("Highpersonalization") }}
              </div>
            </div>
            <div class="wrap-btn" v-if="scriptList.length == 0">
              <a-button
                class="btn"
                type="primary"
                :class="[lang]"
                style="
                  background-color: rgba(64, 149, 229, 1);
                  border-color: rgba(64, 149, 229, 1);
                "
                @click="StartCustomizationHandler"
                >{{ $t("StartCustomization") }}</a-button
              >
            </div>
            <div class="wrap-btn wrap-btn2" v-else>
              <a-button
                class="btn edit"
                type="primary"
                :class="[lang]"
                style="
                  width: 60px;
                  background-color: rgba(64, 149, 229, 1);
                  border-color: rgba(64, 149, 229, 1);
                "
                @click="StartCustomizationHandler"
                >{{ $t("Edit") }}</a-button
              >
              <a-button
                class="btn select"
                :class="[lang]"
                type="primary"
                @click="selectHandler2"
                >{{ $t("Select") }}</a-button
              >
            </div>
          </div>

          <div class="method-card" :body-style="{ padding: '20px' }">
            <div class="wrap-icon"><a-icon class="icon" type="tool" /></div>
            <div class="title" :class="[lang]">
              {{ $t("WorkflowCustomization") }}
            </div>

            <div class="description" :class="[lang]">
              {{ $t("Fullycustomize") }}
            </div>
            <div style="height: 99px; margin-bottom: 18px">
              <div
                class="contact-info"
                :class="[lang]"
                v-html="getEmail()"
              ></div>
            </div>

            <div class="wrap-btn">
              <!-- <a-button
              :class="[lang]"
              class="btn"
              type="primary"
              style="
                background-color: rgba(184, 134, 248, 1);
                border-color: rgba(184, 134, 248, 1);
              "
              @click="selectMethod(1)"
              >Contact us</a-button
            > -->

              <a
                :class="[lang]"
                class="btn btnMail"
                href="mailto:info@strategybrain.com"
                >{{ $t("Contactus") }}</a
              >
            </div>
          </div>
        </div>
        <!-- 底部导航 -->
        <div class="footer">
          <a-button :class="[lang]" @click="goBack">{{ $t("Back") }}</a-button>
        </div>
      </template>
      <EditScript
        :scriptList="scriptList"
        :lgList="lgList"
        :campaign_id="campaign_id || $route.query.campaign_id"
        @saveDraft="saveDraft"
        :complete="complete"
        @backHandler="backHandler"
        @setFromStep="setFromStep"
        :fromStep="fromStep"
        :tempDefaultData="tempDefaultData"
        @setTempDefaultData="setTempDefaultData"
        @getScriptListHandler="getScriptlist"
        @showStep3="showStep3"
        :campaign_type="campaign_type"
        v-if="step == 2"
      >
      </EditScript>
      <!-- <AiTraining
        @backHandler="backHandler"
        @setFromStep="setFromStep"
        @getScriptList="getScriptlist"
        v-if="step == 3"
      ></AiTraining> -->
      <Consultation
        :campaign_type="campaign_type"
        :campaign_id="campaign_id || $route.query.campaign_id"
        :fromStep="fromStep"
        @backHandler="backHandler"
        @publishDirectly="publishDirectly"
        v-if="step == 3"
      >
      </Consultation>
      <a-modal
        centered
        :title="$t('DefaultDialogue')"
        :visible="visible"
        :confirm-loading="confirmLoading"
        cancelText="Return to Option"
        width="800px"
        okText="Confirm Selection"
        :footer="null"
        @cancel="cancelHandler"
      >
        <div
          class="modal-body"
          v-if="lgList.length > 0"
          :style="{ height: dialogHeight + 'px' }"
        >
          <div class="item-box">
            <div class="title">
              <span class="index">1</span
              >{{ campaign_type == 1 ? $t("InitialOutreach") : $t("hrTitle1") }}
            </div>
            <div class="des">
              {{
                campaign_type == 1 ? $t("Sendpersonalized") : $t("hrSubtitle1")
              }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="formatText(lgList[0].translated_content)"
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">2</span
              >{{
                campaign_type == 1 ? $t("PainPointDiscovery") : $t("hrTitle2")
              }}
            </div>
            <div class="des">
              {{ campaign_type == 1 ? $t("Probedeeper") : $t("hrSubtitle2") }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="formatText(lgList[1].translated_content)"
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">3</span
              >{{
                campaign_type == 1 ? $t("ProductAlignment") : $t("hrTitle3")
              }}
            </div>
            <div class="des">
              {{
                campaign_type == 1 ? $t("Connectproduct") : $t("hrSubtitle3")
              }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="formatText(lgList[2].translated_content)"
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">4</span
              >{{ campaign_type == 1 ? $t("QASupport") : $t("hrTitle4") }}
            </div>
            <div class="des">
              {{
                campaign_type == 1 ? $t("RespondingtoUser") : $t("hrSubtitle4")
              }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="formatText(lgList[3].translated_content)"
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">5</span
              >{{ campaign_type == 1 ? $t("ContactCapture") : $t("hrTitle5") }}
            </div>
            <div class="des">
              {{ campaign_type == 1 ? $t("Guideusers") : $t("hrSubtitle5") }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="formatText(lgList[4].translated_content)"
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">6</span
              >{{ campaign_type == 1 ? $t("WhenUsers") : $t("hrTitle6") }}
            </div>
            <div class="des">
              {{ campaign_type == 1 ? $t("Responsewhen") : $t("hrSubtitle6") }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="formatText(lgList[5].translated_content)"
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">7</span
              >{{ campaign_type == 1 ? $t("NeedsMismatch") : $t("hrTitle7") }}
            </div>
            <div class="des">
              {{
                campaign_type == 1
                  ? $t("Responsewhenrequirements")
                  : $t("hrSubtitle5")
              }}
            </div>
            <div class="cont-box">
              <div class="stitle">
                {{ $t("SampleMessage") }}
              </div>
              <div
                class="cont"
                v-html="formatText(lgList[6].translated_content)"
              ></div>
            </div>
          </div>
          <div class="item-box" v-if="campaign_type == 2">
            <div class="title">
              <span class="index">8</span>{{ $t("hrTitle8") }}
            </div>
            <div class="des">
              {{ $t("hrSubtitle8") }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="formatText(lgList[7].translated_content)"
              ></div>
            </div>
          </div>
        </div>
        <div class="footer">
          <a-button
            size="large"
            :class="[lang]"
            @click="cancelHandler"
            style="
              background-color: rgba(0, 0, 0, 0.4);
              color: #fff;
              margin-right: 10px;
            "
            >{{ $t("ReturntoOptions") }}</a-button
          >
          <a-button
            :class="[lang]"
            size="large"
            type="primary"
            @click="handleOk"
            >{{ $t("ConfirmSelection") }}</a-button
          >
        </div>
      </a-modal>
      <a-modal
        centered
        :title="$t('Customscriptpreview')"
        :visible="visible2"
        :confirm-loading="confirmLoading"
        cancelText="Return to Option"
        width="800px"
        okText="Confirm Selection"
        :footer="null"
        @cancel="cancelHandler2"
      >
        <div
          class="modal-body"
          :style="{ height: dialogHeight + 'px' }"
          v-if="scriptList && scriptList.length > 0"
        >
          <div class="item-box">
            <div class="title">
              <span class="index">1</span
              >{{ campaign_type == 1 ? $t("InitialOutreach") : $t("hrTitle1") }}
            </div>
            <div class="des">
              {{
                campaign_type == 1 ? $t("Sendpersonalized") : $t("hrSubtitle1")
              }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="
                  formatText(scriptList[0] && scriptList[0].simulate_content)
                "
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">2</span
              >{{
                campaign_type == 1 ? $t("PainPointDiscovery") : $t("hrTitle2")
              }}
            </div>
            <div class="des">
              {{ campaign_type == 1 ? $t("Probedeeper") : $t("hrSubtitle2") }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="
                  formatText(scriptList[1] && scriptList[1].simulate_content)
                "
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">3</span
              >{{
                campaign_type == 1 ? $t("ProductAlignment") : $t("hrTitle3")
              }}
            </div>
            <div class="des">
              {{
                campaign_type == 1 ? $t("Connectproduct") : $t("hrSubtitle3")
              }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="
                  formatText(scriptList[2] && scriptList[2].simulate_content)
                "
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">4</span
              >{{ campaign_type == 1 ? $t("QASupport") : $t("hrTitle4") }}
            </div>
            <div class="des">
              {{
                campaign_type == 1 ? $t("RespondingtoUser") : $t("hrSubtitle4")
              }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="
                  formatText(scriptList[3] && scriptList[3].simulate_content)
                "
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">5</span
              >{{ campaign_type == 1 ? $t("ContactCapture") : $t("hrTitle5") }}
            </div>
            <div class="des">
              {{ campaign_type == 1 ? $t("Guideusers") : $t("hrSubtitle5") }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="
                  formatText(scriptList[4] && scriptList[4].simulate_content)
                "
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">6</span
              >{{ campaign_type == 1 ? $t("WhenUsers") : $t("hrTitle6") }}
            </div>
            <div class="des">
              {{ campaign_type == 1 ? $t("Responsewhen") : $t("hrSubtitle6") }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="
                  formatText(scriptList[5] && scriptList[5].simulate_content)
                "
              ></div>
            </div>
          </div>
          <div class="item-box">
            <div class="title">
              <span class="index">7</span
              >{{ campaign_type == 1 ? $t("NeedsMismatch") : $t("hrTitle7") }}
            </div>
            <div class="des">
              {{
                campaign_type == 1
                  ? $t("Responsewhenrequirements")
                  : $t("hrSubtitle7")
              }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="
                  formatText(scriptList[6] && scriptList[6].simulate_content)
                "
              ></div>
            </div>
          </div>
          <div class="item-box" v-if="campaign_type == 2">
            <div class="title">
              <span class="index">8</span>{{ $t("hrTitle8") }}
            </div>
            <div class="des">
              {{ $t("hrSubtitle8") }}
            </div>
            <div class="cont-box">
              <div class="stitle">{{ $t("SampleMessage") }}</div>
              <div
                class="cont"
                v-html="
                  formatText(scriptList[7] && scriptList[7].simulate_content)
                "
              ></div>
            </div>
          </div>
        </div>
        <div class="footer">
          <a-button
            size="large"
            :class="[lang]"
            @click="cancelHandler2"
            style="
              background-color: rgba(0, 0, 0, 0.4);
              color: #fff;
              margin-right: 10px;
            "
            >{{ $t("ReturntoOptions") }}</a-button
          >
          <a-button
            :class="[lang]"
            size="large"
            type="primary"
            @click="handleOk2"
            >{{ $t("ConfirmSelection") }}</a-button
          >
        </div>
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
import { debounce } from "@/utils/util";
import EditScript from "./editScript.vue";
// import AiTraining from "./aiTraining.vue";
import Consultation from "./consultation.vue";
export default {
  data() {
    return {
      tempDefaultData: null,
      loading: false,
      // 0 是新建 1是已创建
      complete: 0,
      visible: false,
      visible2: false,
      confirmLoading: false,
      ModalText: "Content of the modal",
      dialogHeight: 500,
      scriptList: [],
      step: 1,
      fromStep: 1,
      lgList: [],
    };
  },
  props: ["campaign_id", "isBacked", "campaign_type"],
  components: { EditScript, Consultation },
  i18n: require("./i18n"),
  created() {
    if (this.isBacked || !this.$route.query.workStep) {
      this.step = 1;
      // this.step = 4;
    } else if (this.$route.query.workStep) {
      this.step = this.$route.query.workStep;
    }
    this.getDefaultScripts().then((list) => {
      this.lgList = list;
      this.getScriptlist(true);
    });
  },
  watch: {
    campaign_id(val) {
      if (val && this.fromStep == 1) {
        if (this.campaign_type == 1) {
          this.$router.replace({
            path: "/sales/salesReps/createCampaign",
            query: {
              edit: 3,
              campaign_id: parseInt(val),
              stepNum: 5,
              workStep: 3,
            },
          });
        } else {
          this.$router.replace({
            path: "/hr/recruiter/createCampaign",
            query: {
              edit: 3,
              campaign_id: parseInt(val),
              stepNum: 5,
              workStep: 3,
            },
          });
        }
      }
    },
    lang() {
      this.getScriptlist();
    },
  },

  mounted() {
    setTimeout(() => {
      this.resizeWindow();
    }, 200);
    window.addEventListener("resize", debounce(this.resizeWindow, 300), false);
  },
  methods: {
    getDefaultScripts() {
      return new Promise((resolve, reject) => {
        this.$axios(
          "/public/get_dialogue_examples",
          { campaign_id: parseInt(this.campaign_id) },
          "post",
        ).then((res) => {
          if (res.code == 200) {
            resolve(res.data);
          } else {
            reject(res.msg);
          }
        });
      });
    },
    formatText(text) {
      const msg = text
        .replace(/\n/g, "<br>")
        .replace(/\r/g, "<br>")
        .replace(/。/g, "。<br>");
      return msg;
    },
    setTempDefaultData(data) {
      this.tempDefaultData = data;
    },
    getScriptlist(noload) {
      let { campaign_id } = this.$route.query;
      campaign_id = campaign_id || this.campaign_id;
      if (campaign_id) {
        if (noload) {
          this.loading = true;
        }

        this.$axios(
          "/sales/get_campaign_scripts",
          { campaign_id: parseInt(campaign_id) },
          "post",
        ).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.scriptList = res.data.scripts || [];
            if (this.scriptList.length == 8 && this.campaign_type == 1) {
              this.scriptList = this.scriptList.slice(
                0,
                this.scriptList.length - 1,
              );
            }
          }
        });
      }
    },
    publishDirectly() {
      this.$emit("publishDirectlyHandler");
    },
    showStep3(val) {
      this.step = val;
    },
    goBack() {
      this.$emit("backHandler");
    },
    setFromStep(step) {
      this.fromStep = step;
    },
    backHandler(step) {
      this.step = step;
    },
    saveDraft() {
      this.$emit("saveDraftHandler");
    },
    StartCustomizationHandler() {
      this.step = 2;
    },
    getEmail() {
      return this.$t("Needtailored").replace(
        "info@strategybrain.com",
        '<a href="mailto:info@strategybrain.com">info@strategybrain.com</a>',
      );
    },
    resizeWindow() {
      var h =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.dialogHeight = h - 200 - 120;
      var bottomHeight = document.querySelector(".bottom")
        ? document.querySelector(".bottom").clientHeight
        : 0;
      this.bottomHeight = bottomHeight;
      let dialogHeight = h - bottomHeight - 50 - 64 - 30 - 16 - 40 - 80 - 60;

      this.maxWindowHeight = dialogHeight;
      //this.setScroll();
    },

    selectHandler() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
      if (this.$route.query.campaign_id) {
        this.step = 3;
        this.setFromStep(1);
      }
    },
    cancelHandler() {
      this.visible = false;
    },
    selectHandler2() {
      this.visible2 = true;
    },
    handleOk2() {
      this.visible2 = false;
      this.step = 3;
      this.setFromStep(1);
    },
    cancelHandler2() {
      this.visible2 = false;
    },
    selectMethod(method) {
      console.log(`Selected method: ${method}`);
    },
  },
};
</script>

<style scoped>
.workshop-container {
  padding: 20px 20px 0;
}

.header {
  text-align: center;
  margin-bottom: 20px;

  .title {
    font-size: 24px;
    margin: 0 0 10px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;

    .icon {
      margin-right: 5px;
      font-size: 24px;
      color: #0e756a;
    }
  }

  .subtitle {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.52);
  }
}

.m-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .icon {
    font-size: 24px;
    margin-right: 5px;
  }

  font-size: 16px;
  font-weight: bold;
}

.setup-methods {
  display: flex;
  justify-content: space-between;

  .method-card {
    width: 32%;
    text-align: center;
    border: 1px solid #ccc;
    padding: 16px;
    border-radius: 4px;

    .wrap-icon {
      margin-top: 14px;
      text-align: center;

      .icon {
        font-size: 30px;
      }
    }

    .title {
      margin-top: 18px;
      font-size: 16px;
      font-weight: bold;
      height: 48px;
    }

    .description {
      font-size: 14px;

      height: 56px;
      line-height: 28px;
      /* margin-top: 16px; */
      margin-bottom: 40px;
      color: rgba(0, 0, 0, 0.52);
    }

    .features {
      .item {
        .icon {
          color: #0e756a;
          margin-right: 5px;
          font-size: 18px;
        }

        color: rgba(0, 0, 0, 0.52);
        font-size: 14px;
        margin-bottom: 18px;
        display: flex;
        text-align: left;
      }
    }

    .contact-info {
      border-radius: 10px;
      background-color: rgba(239, 239, 239, 1);
      padding: 16px;
      border-radius: 6px;
      margin-bottom: 20px;
    }

    .wrap-btn {
      .btn {
        width: 100%;
        margin-top: 20px;
      }

      margin-bottom: 20px;
    }

    .wrap-btn2 {
      display: flex;
      justify-content: space-between;

      .edit {
        width: 50px;
        margin-right: 10px;
      }

      .btn {
        width: 100%;
        margin-top: 20px;
      }

      .select {
        flex: 1;
      }

      margin-bottom: 20px;
    }
  }

  .contact-info {
    margin-top: 20px;
    color: #666;
  }
}

.modal-body {
  overflow-y: auto;

  .item-box {
    border-radius: 10px;
    background-color: rgba(239, 239, 239, 1);
    padding: 16px;
    margin-bottom: 12px;

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .index {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        border-radius: 50%;
        background-color: rgba(16, 117, 106, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        text-align: center;
        font-family: PingFangSC-bold;
        margin-right: 5px;
      }

      color: rgba(0, 0, 0, 1);
      font-size: 16px;
      text-align: left;
      font-family: PingFangSC-bold;
    }

    .des {
      color: rgba(0, 0, 0, 0.4);
      font-size: 12px;
      text-align: left;
      font-family: PingFangSC-regular;
      margin-bottom: 12px;
    }

    .cont-box {
      background: #fff;
      border-left: rgba(16, 117, 106, 1) solid 8px;
      border-radius: 6px;
      padding: 16px;
      font-size: 14px;

      .stitle {
        color: rgba(16, 117, 106, 1);
        text-align: left;
        font-family: PingFangSC-bold;
        margin-bottom: 8px;
      }

      .cont {
        line-height: 22px;
      }
    }
  }
}

.btnMail {
  background-color: rgba(184, 134, 248, 1);
  border-color: rgba(184, 134, 248, 1);
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  display: inline-block;
  border-radius: 4px;
}

.footer {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 30px;
}

/**chatloading */
.loading_chat,
.loading-chat > div {
  position: relative;
  box-sizing: border-box;
}

.loading-chat {
  display: block;
  font-size: 0;
  color: #0e756a;
}

.loading-chat.la-dark {
  color: #333;
}

.loading-chat > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}

.loading-chat {
  width: 64px;
  height: 18px;
}

.loading-chat > div:nth-child(1) {
  animation-delay: -200ms;
}

.loading-chat > div:nth-child(2) {
  animation-delay: -100ms;
}

.loading-chat > div:nth-child(3) {
  animation-delay: 0ms;
}

.loading-chat > div {
  width: 10px;
  height: 10px;
  margin: 4px;
  border-radius: 100%;
  animation: ball-pulse 1s ease infinite;
}

.loading-chat.la-sm {
  width: 26px;
  height: 8px;
}

.loading-chat.la-sm > div {
  width: 4px;
  height: 4px;
  margin: 2px;
}

.loading-chat.la-2x {
  width: 108px;
  height: 36px;
}

.loading-chat.la-2x > div {
  width: 20px;
  height: 20px;
  margin: 8px;
}

.loading-chat.la-3x {
  width: 162px;
  height: 54px;
}

.loading-chat.la-3x > div {
  width: 30px;
  height: 30px;
  margin: 12px;
}

@keyframes ball-pulse {
  0%,
  60%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  30% {
    opacity: 0.1;
    transform: scale(0.01);
  }
}

.loading-link {
  position: relative;
  width: 15px;
  height: 15px;
  border: 2px solid #666;
  border-top-color: rgba(0, 0, 0, 0.2);
  border-right-color: rgba(0, 0, 0, 0.2);
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-radius: 100%;

  animation: circle infinite 0.75s linear;
}

@keyframes circle {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

.thinking {
  display: flex;
  align-items: center;

  .text {
    margin-right: 10px;
  }
}
</style>
